import React from 'react';
import {Icon} from 'shared/helpers';
import styled from 'styled-components';
import {useJobContext} from 'contexts/JobContext';
import {PartialJob} from 'shared/types/PartialJob';

export const JobHeader = () => {
    const {job} = useJobContext() as PartialJob;

    return (
        <Header>
            <Icon iconName="cart-white-bg.svg" />
            <label>
                #{job.displayId} {job.name}
            </label>
        </Header>
    );
};

const Header = styled.h1`
    margin-bottom: 5px;
`;
